import { Injectable } from '@angular/core';
import { ProductPageMetaResolver } from '@spartacus/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class CustomProductPageMetaResolver extends ProductPageMetaResolver {
  override resolveHeading(): Observable<string> {
    return of('Back to Products');
  }
}
